import { Box } from "@mui/material"
import { Outlet, useLocation } from "react-router-dom"

const Layout = () => {
    const location = useLocation();

    // 🛑 รายชื่อ Route ที่ "ไม่ต้องการ" ให้ระบบเว้นระยะห่างด้านบน 
    const noPaddingRoutes = ['/', '/login', '/register', '/survey/print', '/survey/billboard/print', '/ptas/print'];

    // ตรวจสอบเช็คหน้าปัจจุบันว่าต้องหลบหลีกระยะบาร์หรือไม่
    const shouldAddPadding = !noPaddingRoutes.includes(location.pathname);
    const padding = '75px';

    // 🟢 เช็คว่าถ้าเป็นหน้าแรก ('/') ให้ใช้สีน้ำเงินเข้มของน้อง แต่ถ้าเป็นหน้าอื่นให้ใช้สีเทาอ่อนเพื่อให้พนักงานคีย์งานสบายตา
    const isHomePage = location.pathname === '/';
    const bgBackgroundColor = isHomePage ? '#025464' : '#f4f6f8';

    return (
        <Box 
            className="App" 
            sx={{ 
                minHeight: '100vh',
                bgcolor: bgBackgroundColor,
                position: 'relative',
                transition: 'background-color .3s ease'
            }}
        >
            {/* 🟢 สวมคลาส .otherSide ของน้องไว้ที่ Layout หลักที่นี่จุดเดียวเลย มีผลบังคับใช้ทุกหน้าลูกทันที! */}
            <Box
                component="main"
                className="otherSide" 
                sx={{
                    pt: shouldAddPadding ? padding : '0px',
                    boxSizing: 'border-box',
                    transition: 'padding .3s ease, margin-left .5s',
                    // ดึงคุณสมบัติ CSS ดั้งเดิมมาคุมผ่านระบบ MUI แบคอัพป้องกันอีกชั้น
                    position: 'absolute', 
                    width: '100%',
                    minWidth: '-webkit-fill-available',
                    minHeight: '-webkit-fill-available',
                    backgroundColor: bgBackgroundColor, // คอนโทรลสลับสีตามหน้างาน
                }}
            >
                {/* 🚪 คอมโพเนนต์ลูกทุกหน้า (HomePage, UserManage, EditSurvey) จะวิ่งมาพ่นตรงนี้ พร้อมสวมคลาสสไตล์เรียบร้อย */}
                <Outlet />
            </Box>
        </Box>
    )
}

export default Layout;